module.exports = __webpack_public_path__ + "img/sensor_ok.f7b2b54a.svg";